import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import {BottoneAPI, Trad, BaseComponent} from '../components/';

interface ILoginState {
    ID_Utente: number;
    Login: string;
    Password: string;
    OTP: string;
    SecondaPassword: boolean;
}

export class Login extends BaseComponent<Glob.IRouteGlobaleProps, ILoginState> {
    public constructor(props: any) {
        super(props);
        this.state = {Login: "", Password: "", ID_Utente: 0, SecondaPassword: false, OTP: ""};
        this.OnChange = this.OnChange.bind(this);
    }

    private OnClickLogin(sender: BottoneAPI, dati: Dati.CRisAPIDatoSessioni) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto));
            this.setState({SecondaPassword: dati.ErrTesto == "ErroreLoginOTPCodice", OTP: ""});
        } else {
            if (dati.Dato.SecondaPassword) {
                this.setState({SecondaPassword: true, OTP: ""});
            } else {
                let S = Glob.GetSessione();
                S.Autorizzazioni = dati.Dato.Autorizzazioni;
                S.Cognome = dati.Dato.Cognome;
                S.ConfigurazioneCompilazione = dati.Dato.ConfigurazioneCompilazione;
                S.Email = dati.Dato.Email;
                S.Gruppi = dati.Dato.Gruppi;
                S.ID_Anag = dati.Dato.ID_Anag;
                S.ID_Utente = dati.ID_Chiave;
                S.ID_UtenteImpersonato = dati.Dato.ID_UtenteImpersonato;
                S.Immagine = dati.Dato.Immagine;
                S.Limiti = dati.Dato.Limiti;
                S.Livello = dati.Dato.Livello;
                S.Login = dati.Dato.Login;
                S.Nome = dati.Dato.Nome;
                S.Scadenza = dati.Dato.Scadenza;
                S.ScadenzaMax = dati.Dato.ScadenzaMax;
                S.Sessione = dati.Dato.Sessione;
                S.Versione = dati.Dato.Versione;
                this.props.SetSessione(S);

                this.props.history.push('/dashboard');
            }
        }
    }

    private OnClickRecuperaPassword(sender: BottoneAPI, dati: Dati.CRisAPIDatoSessioni) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto));
        } else {
            Glob.InfoModaleSuccess(Trad.Trad("Recupera password"), Trad.Trad("ControllareLaPropriaCasellaEmail"));
        }
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
        Glob.InfoModaleError(Trad.Trad("ERRORE"), errore.message);
    }

    public render() {
        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="portlet__head">
                    <span className="portlet__head-icon hidden">
                        <i className="la la-gear"></i></span>
                    <h3 className="portlet__head-text">{Trad.Trad("Login")}</h3>
                </div>
            </div>
            <form className="kt-form login-form login">
                <div className="kt-portlet__body">
                    <div className="form-group special-group kt-form login-form__group">
                        <div className="kt-input-icon kt-input-icon--left">
                            <input className="form-control kt-input" placeholder="Username"
                                   id="Login" type="text" required value={this.state.Login}
                                   onChange={this.OnChange} autoComplete="username"/>
                            <span
                                className="kt-input-icon__icon kt-input-icon__icon--left"><span><i
                                className="fa fa-user"></i></span></span>
                        </div>
                    </div>
                    <div className="form-group special-group kt-form login-form__group">
                        <div className="kt-input-icon kt-input-icon--left">
                            <input className="form-control kt-input" placeholder="Password"
                                   type="password" id="Password" required
                                   value={this.state.Password} onChange={this.OnChange}
                                   autoComplete="current-password"/>
                            <span
                                className="kt-input-icon__icon kt-input-icon__icon--left"><span><i
                                className="fa fa-lock"></i></span></span>
                        </div>
                    </div>
                    {this.state.SecondaPassword &&
                    <div className="form-group kt-form login-form__group">
                        <div className="kt-input-icon kt-input-icon--left">
                            <input className="form-control kt-input" placeholder="OTP"
                                   type="password" id="OTP" required value={this.state.OTP}
                                   onChange={this.OnChange} autoComplete="off"/>
                            <span
                                className="kt-input-icon__icon kt-input-icon__icon--left"><span><i
                                className="fa fa-unlock"></i></span></span>
                        </div>
                    </div>}
                </div>
                <div className="kt-portlet__no-border kt-portlet__foot--fit">
                    <div className="kt-form login-form__actions form-footer">
                        <div className="divtabella">
                            <BottoneAPI Default Testo={Trad.Trad("Login")} URL="/api/Utenti/Login"
                                        ParamURLClasse={this.state}
                                        OnClick={(s, d) => this.OnClickLogin(s, d)}
                                        OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}/>
                        </div>
                        <div className="divtabella">
                            <BottoneAPI Testo={Trad.Trad("Recupera password")}
                                        URL="/api/Utenti/RichiediRecuperaPassword"
                                        ParamURLClasse={this.state}
                                        OnClick={(s, d) => this.OnClickRecuperaPassword(s, d)}
                                        OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}/>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/form/Login.tsx